import React, { useState, memo, useEffect } from "react";
import AgComponents from "./AgComponents";
import MediaFiles from "././MediaFiles/MediaFiles";
import TemplateComponents from "./TemplateComponents";
import AiMedia from "./AiMedia";
import dropdownIcon from "../../../assets/dropdown-icon.svg";

const LibraryPanel = ({
  activeTab,
  searchQuery,
  setSearchQuery,
  onItemDoubleClick,
}) => {
  const [inputValue, setInputValue] = useState(searchQuery);

  // Use a single useEffect to handle tab changes and clear search
  useEffect(() => {
    // Clear the search query when the active tab changes
    setSearchQuery("");
  }, [activeTab, setSearchQuery]);

  useEffect(() => {
    setInputValue(searchQuery);
  }, [searchQuery]);

  //Handle the key press event on the input field.
  const handleSearchKeyDown = (event) => {
    if (event.key === "Enter") {
      // Set the parent's search query state to trigger the filter.
      setSearchQuery(inputValue);
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case "elements":
        return (
          <AgComponents
            onItemDoubleClick={onItemDoubleClick}
            searchQuery={searchQuery}
          />
        );

      case "templates":
        return (
          <TemplateComponents
            onItemDoubleClick={onItemDoubleClick}
            searchQuery={searchQuery}
          />
        );

      case "uploads":
        return (
          <MediaFiles
            onItemDoubleClick={onItemDoubleClick}
            searchQuery={searchQuery}
          />
        );

      case "aiMedia":
        return (
          <AiMedia
            onItemDoubleClick={onItemDoubleClick}
            searchQuery={searchQuery}
          />
        );
      default:
        return <div className="text-white">Select a tab</div>;
    }
  };

  const getTitle = () => {
    switch (activeTab) {
      case "elements":
        return "Elements";
      case "templates":
        return "Templates";
      case "uploads":
        return "Uploads";
      case "aiMedia":
        return "AI Media";
      default:
        return "Library";
    }
  };

  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="py-4 border-ag-black-400 relative">
        <h2 className="text-base font-regular text-white text-center">
          {getTitle()}
        </h2>
      </div>

      {/* Search bar */}
      <div className="px-4">
        <div className="relative">
          <input
            type="text"
            placeholder="Search..."
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleSearchKeyDown}
            className="w-full pl-4 pr-3 py-2 bg-ag-black-800 border border-ag-black-400 rounded-md text-sm text-white focus:outline-none focus:ring-2 focus:ring-ag-green focus:border-transparent"
          />
          {/* <button
            className="absolute right-2 top-1/2 transform -translate-y-1/2 px-2 py-2
                            text-sm rounded-md bg-ag-black-700 border border-ag-black-400
                             hover:bg-ag-green transition-colors"
          >
            <img
              src={dropdownIcon}
              alt="dropdown Logo"
              className="h-2 w-auto hover:invert"
            />
          </button> */}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 min-h-0 p-4">{renderContent()}</div>
    </div>
  );
};

export default memo(LibraryPanel);
